import React from "react";
import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const EmailWithPaintDrop2Svg = () => (
  <svg
    width="1em"
    height="0.82em"
    viewBox="0 0 33 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.5"
      d="M11.6939 26.0659C18.8736 26.0659 24.6938 20.2456 24.6938 13.0659L24.6938 12.7467C24.6938 5.74328 19.0165 0.0658874 12.013 0.0658873C5.86222 0.0658872 0.875992 5.05212 0.875992 11.2029L0.875992 26.0659L11.6939 26.0659Z"
      fill="url(#paint0_linear_2_20857)"
    />
    <path
      d="M12.1245 6.06593H28.1245C29.2245 6.06593 30.1245 6.96593 30.1245 8.06593V20.0659C30.1245 21.1659 29.2245 22.0659 28.1245 22.0659H12.1245C11.0245 22.0659 10.1245 21.1659 10.1245 20.0659V8.06593C10.1245 6.96593 11.0245 6.06593 12.1245 6.06593Z"
      stroke="#3F3D56"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M30.1245 8.06593L20.1245 15.0659L10.1245 8.06593"
      stroke="#3F3D56"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
    <linearGradient
      id="paint0_linear_2_20857"
      x1="16.4296"
      y1="29.4289"
      x2="28.4719"
      y2="13.2449"
      gradientUnits="userSpaceOnUse"
    >
      <stop stopColor="#819585"/>
      <stop offset="0.396113" stopColor="#91A999"/>
      <stop offset="1" stopColor="#ADC8B6"/>
    </linearGradient>
    </defs>
  </svg>

);

export const EmailWithPaintDrop2Icon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={EmailWithPaintDrop2Svg} {...props} />
);
